import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type VoidReason = definitions['types.VoidReason'];

const service = {
  getAll: coreService['POS:GET:VoidReasons'],
};

export default service;
export type { VoidReason };
